<script>
export default {
  name: "hitchRideOrderDispatchMap",
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      map: null,
      markerBegin: null,
      markerEnd: null,
      markerDriverList: new Map(),
      infoWindow: null,
      form: {
        range: 5,
        lng: '',
        lat: '',
      }
    }
  },
  mounted() {
    this.form.range = this.rowData.cityType === 1 ? 20 : 5
    this.form.lng = this.rowData.startPointLng
    this.form.lat = this.rowData.startPointLat
    this.form.organizationId = this.rowData.organizationId
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {

    async getVehicleDriver() {
      let url = "/api/v1/manage/order/hitchRide/ranges/driver";
      let data = await this.$axios.get(url, this.form);
      if (data && data.code == 1) {
        if (this.infoWindow) {
          this.infoWindow.close();
        }
        this.map.remove([...this.markerDriverList.values()]);
        this.markerDriverList.clear();
        if (data.data && data.data.length > 0) {
          data.data.forEach((item) => {
            this.drawVehicleMarker(item);
          });
          setTimeout(() => {
            this.map.setFitView([this.markerBegin, ...this.markerDriverList.values()], false, [100, 100, 100, 100])
          }, 500)
        }
      }
    },
    drawVehicleMarker(drawInfo) {
      const content = `<img style="width: 60px;" src="${require('@/assets/img/dispatchsijitouxiang.png')}"/>`
      let marker = new AMap.Marker({
        position: [drawInfo.location.longitude, drawInfo.location.latitude],
        content: content,
        draggable: true,
        anchor: "top-center",
        offset: new AMap.Pixel(-1, -28),
        zIndex: 500,
        map: this.map,
      });
      marker.on("click", (e) => {
        // 点击司机marker点展示，打开展示司机信息的信息窗体,并调用司机信息
        this.infoWindow.open(this.map, marker.getPosition());
        this.getDriverInfoWindowFn(e.target.driverId, drawInfo);
      });
      marker["driverId"] = drawInfo.driverId;
      marker['drawInfo'] = drawInfo
      this.markerDriverList.set(drawInfo.driverId, marker)

    },
    getDriverInfoWindowFn(id, drawInfo) {

      const content = `<div class="cardInfo">
           <div class="items">姓名：${drawInfo.driverName}</div>
           <div class="items">电话：${drawInfo.driverPhone}</div>
           <div class="items">车辆：${drawInfo.licenseNo}</div>
        </div>`
      this.infoWindow.setContent(content);
    },

    async initMap() {
      this.map = new AMap.Map("order-map", {
        // mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        mapStyle: 'amap://styles/117929a1925007df896212a1031807f5',
        animateEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      this.infoWindow = new AMap.InfoWindow({
        isCustom: true, // 使用自定义窗体
        content: '', // 传入 dom 对象，或者 html 字符串
        offset: new AMap.Pixel(0, -15),
      });
      await this.getMarker(this.rowData)
      await this.getVehicleDriver()
      this.map.on("click", () => {
        if (this.infoWindow) {
          this.infoWindow.close();
        }
      });
    },
    getMarker(row) {
      if (this.markerEnd && this.markerBegin) {
        this.map.remove([this.markerEnd, this.markerBegin])
      }
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div>上车地点：${row.startPointName}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div>下车地点：${row.endPointName}</div>
                          </div>`;
      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(row.startPointLng, row.startPointLat),
        icon: require("@/assets/img/markerBegin.png"),
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });
      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(row.endPointLng, row.endPointLat),
        icon: require("@/assets/img/markerEnd.png"),
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });
      this.map.add([this.markerEnd, this.markerBegin])
      this.map.setFitView([this.markerBegin, this.markerEnd], false, [100, 100, 100, 100]);
    },
  }
}
</script>

<template>
  <div class="hitchRideOrderDispatchMap">
    <div>
      <el-form
          ref="formI"
          label-width="80px"
          label-position="left"
      >
        <el-form-item style="width: 400px" label="搜索范围">
          <div class="flex-start">
            <div style="width: 80%">
              <el-slider @change="getVehicleDriver" :max="20" :min="1" v-model="form.range"></el-slider>
            </div>
            <span style="padding-left: 10px"> ({{ form.range }}公里)</span>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div id="order-map"></div>

  </div>
</template>

<style lang="less">
.hitchRideOrderDispatchMap {
  width: 100%;
  height: 100%;

  #order-map {
    width: 100%;
    height: 800px;

    .cardInfo {
      background-color: white !important;
      box-shadow: 0px 4px 16px 0px rgba(127, 103, 86, 0.1);
      border-radius: 8px;
      padding: 12px;
      box-sizing: border-box;

      .items {
        margin-bottom: 4px;
        color: #333333;
      }
    }
  }

  /deep/ .el-form-item__label {
    line-height: 40px;
  }


}


</style>